<div fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="12px">
    <div fxLayout.gt-sm fxLayoutGap="12px" fxLayoutAlign="start center">
        @if (!data().hideAssign) {
            <cipo-select
                fxFlex
                class="input-container"
                [control]="assignControl"
                [fieldData]="fieldsData().assign"
                data-testid="doc-actions-assign-select" />
        }
        @if (showDocNum()) {
            <cipo-select
                fxFlex
                class="input-container"
                [control]="docNumControl"
                [fieldData]="fieldsData().documentNumber"
                data-testid="doc-actions-doc-num-select" />
        }
    </div>
    <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
        @if (data().formInvalid) {
            <p class="m-l cipo-text--warn-900">{{ "errors.resolveErrors" | translate }}</p>
        }
        @if (data().showCancel) {
            <button mat-raised-button (click)="cancelRequested.emit()" data-testid="doc-actions-cancel-btn">
                {{ "actions.cancel" | translate }}
            </button>
        }
        @if (data().submitLabel) {
            <button
                mat-raised-button
                color="primary"
                (click)="submitRequested.emit()"
                data-testid="doc-actions-submit-btn"
                [disabled]="data().disableSubmit || data().disableActions">
                {{ data().submitLabel | translate }}
            </button>
        } @else if (transitions()?.length || workflowActions().length) {
            <button
                mat-raised-button
                color="primary"
                [matMenuTriggerFor]="transitionsMenu"
                data-testid="doc-actions-transitions-btn"
                [disabled]="data().disableActions">
                {{ "actions.actions" | translate }}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
        }
        @if (actions().length) {
            <button
                data-testid="doc-actions-more-actions-btn"
                fxFlex="none"
                mat-icon-button
                class="m-r"
                [matMenuTriggerFor]="actionsMenu"
                [attr.aria-label]="'a11y.common.more' | translate"
                [disabled]="data().disableActions || data().disableMoreActions">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">more_vert</mat-icon>
            </button>
        }
    </div>
</div>

<mat-menu #actionsMenu="matMenu" class="cipo cipo-menu" data-testid="doc-actions-actions-menu">
    @for (item of actions(); track $index) {
        @if (item.id === DropdownActionsEnum.DIVIDER) {
            <div class="cipo--border-bottom--lite m-x-sm"></div>
        } @else if (item.options?.length) {
            <button
                mat-menu-item
                [matMenuTriggerFor]="actionOptionsMenu"
                [matMenuTriggerData]="{ item: item }"
                [attr.data-testid]="'doc-actions-action-item doc-actions-action-item-' + item.id">
                <mat-icon class="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span class="m-l">{{ item.label | translate: item.labelParams }}</span>
            </button>
        } @else {
            <button
                mat-menu-item
                (click)="handleActionClick(item.id)"
                [attr.data-testid]="'doc-actions-action-item doc-actions-action-item-' + item.id">
                <mat-icon class="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span class="m-l">{{ item.label | translate: item.labelParams }}</span>
            </button>
        }
    }
</mat-menu>

<mat-menu #actionOptionsMenu="matMenu" class="cipo cipo-menu">
    <ng-template matMenuContent let-item="item">
        @for (option of item.options; track option.key) {
            <button
                mat-menu-item
                [title]="option.label"
                (click)="actionOptionClicked.emit({ id: item.id, optionKey: option.key })"
                data-testid="doc-actions-action-option">
                {{ option.label }}
            </button>
        }
    </ng-template>
</mat-menu>

<mat-menu #transitionsMenu="matMenu" class="cipo cipo-menu" data-testid="doc-transitions-menu">
    @for (transition of transitions(); track $index) {
        @if (transition.roles?.length > 1) {
            <button
                mat-menu-item
                [disabled]="transition.disabled"
                [matMenuTriggerFor]="rolesMenu"
                [matMenuTriggerData]="{ roles: transition.roles, transitionId: transition.id }"
                [disabled]="data().disableActions"
                [attr.data-testid]="'doc-actions-transition-item doc-actions-transition-item-' + transition.id">
                <span>{{ transition.name }}</span>
            </button>
        } @else {
            <button
                mat-menu-item
                [disabled]="transition.disabled || data().disableActions"
                (click)="transitionClicked.emit(transition)"
                [attr.data-testid]="'doc-actions-transition-item doc-actions-transition-item-' + transition.id">
                <span>{{ transition.name }}</span>
            </button>
        }
    }
    @if (transitions()?.length && workflowActions().length) {
        <div class="cipo--border-bottom--lite m-x-sm"></div>
    }
    @for (item of workflowActions(); track item.id) {
        <button
            mat-menu-item
            [disabled]="data().disableActions || data().disableMoreActions"
            [attr.data-testid]="'doc-actions-workflow-item-' + item.id"
            (click)="handleActionClick(item.id)">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</mat-icon>
            <span class="m-l">{{ item.label | translate: item.labelParams }}</span>
        </button>
    }
</mat-menu>

<mat-menu #rolesMenu="matMenu" class="cipo cipo-menu">
    <ng-template matMenuContent let-roles="roles" let-transitionId="transitionId">
        @for (role of roles; track $index) {
            <button
                mat-menu-item
                (click)="handleTransitionClick(transitionId, role)"
                [disabled]="data().disableActions"
                [attr.data-testid]="'doc-actions-transition-role doc-actions-transition-role-' + role.key">
                {{ role.value }}
            </button>
        }
    </ng-template>
</mat-menu>
